export class ProductCardSwatch extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.handleShowSwatchImageHover =
      this.handleShowSwatchImageHover.bind(this)
    this.handleShowSwatchImageClick =
      this.handleShowSwatchImageClick.bind(this)

    // Flag to determine if we are in desktop mode
    this.isDesktop = window.innerWidth > 768

    // Add initial event listeners based on screen size
    this.updateListeners()

    // Add resize event listener to switch between interactions on screen resize
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  handleResize () {
    const isNowDesktop = window.innerWidth > 768
    if (isNowDesktop !== this.isDesktop) {
      // Only update listeners if the screen size crosses the 768px threshold
      this.isDesktop = isNowDesktop
      this.updateListeners()
    }
  }

  updateListeners () {
    // Remove any existing event listeners
    this.els.swatch.elements.forEach((swatch) => {
      swatch.removeEventListener('mouseenter', this.handleShowSwatchImageHover)
      swatch.removeEventListener('click', this.handleShowSwatchImageClick)

      // Add appropriate event listeners based on screen size
      if (this.isDesktop) {
        // Desktop mode - add mouseenter event
        swatch.addEventListener('mouseenter', this.handleShowSwatchImageHover)
      } else {
        // Mobile mode - add click event
        swatch.addEventListener('click', this.handleShowSwatchImageClick)
      }
    })
  }

  setParentItem (e) {
    this.parentItem = e.target.closest('.prd-Card')
  }

  handleShowSwatchImageHover (e) {
    this.setParentItem(e)
    this.handleShowSwatchImage(e)
    this.handleMainImageLink(e)
    this.handleWishlistLink(e)
    this.handleAddToCartVariant(e)
    this.handleSelectedSwatch(e)
  }

  handleShowSwatchImageClick (e) {
    e.preventDefault() // Prevent default anchor behavior
    e.stopPropagation() // Stop event from bubbling up
    this.setParentItem(e)
    this.handleShowSwatchImage(e)
    this.handleMainImageLink(e)
    this.handleWishlistLink(e)
    this.handleAddToCartVariant(e)
    this.handleSelectedSwatch(e)
  }

  handleShowSwatchImage (e) {
    e.preventDefault() // Prevent default action for anchor tag

    const primaryImage = this.parentItem.querySelector(
      '[data-product-card-swatch-external-el="primaryImage"]',
    )
    const swatchImage = this.parentItem.querySelector(
      '[data-product-card-swatch-external-el="swatchImage"]',
    )
    const swatchImageSrc = swatchImage.querySelector('img')

    primaryImage.style.opacity = 0
    swatchImage.style.opacity = 1
    swatchImageSrc.src = this.querySelector(
      '[data-product-card-swatch-el="swatch"]',
    ).getAttribute('data-product-card-swatch-primary-image')
  }

  handleMainImageLink (e) {
    const hrefItem = e.target.getAttribute('data-product-card-swatch-url')
    const linkElement = this.parentItem.querySelector(
      '[data-product-card-swatch-external-el="href"]',
    )

    linkElement.href = hrefItem
  }

  handleWishlistLink (e) {
    const productUrl = e.target.getAttribute('data-product-card-swatch-url')
    const productId = e.target.getAttribute(
      'data-product-card-swatch-product-id',
    )
    const productVariantUrl = e.target.getAttribute(
      'data-product-card-swatch-variant-url',
    )
    const productVariantId = e.target.getAttribute(
      'data-product-card-swatch-variant-id',
    )
    const wishlistTrigger = this.parentItem.querySelector(
      '[data-wishlist-modal-external-el="trigger"]',
    )

    wishlistTrigger.setAttribute('data-product-url', productUrl)
    wishlistTrigger.setAttribute('data-product-id', productId)
    wishlistTrigger.setAttribute('data-variant-url', productVariantUrl)
    wishlistTrigger.setAttribute('data-variant-id', productVariantId)
  }

  handleSelectedSwatch (e) {
    const swatches = this.parentItem.querySelectorAll(
      '[data-product-card-swatch-el="swatch"]',
    )

    // Set aria-current to false for all swatches
    swatches.forEach((swatch) => swatch.setAttribute('aria-current', 'false'))

    // Set aria-current to true for the clicked swatch
    e.target.setAttribute('aria-current', 'true')
  }

  handleAddToCartVariant (e) {
    const selectedSwatchProductID = e.target.getAttribute(
      'data-product-card-swatch-product-id',
    )
    const selectedSwatchProductUrl = e.target.getAttribute(
      'data-product-card-swatch-url',
    )
    const addToCartButtons = this.parentItem.querySelectorAll(
      '[data-card-modal-external-el="trigger"]',
    )

    addToCartButtons.forEach((button) => {
      button.setAttribute('data-product', selectedSwatchProductUrl)
      button.setAttribute('data-product-id', selectedSwatchProductID)
    })
  }
}

customElements.define('product-card-swatch', ProductCardSwatch)
